import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse
   } from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SessionTimerService } from './services/session-timer.service';
import { Globals } from './objects/Globals';
   
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(private sessionTimerService: SessionTimerService, private globals: Globals){}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).timeout(120000)
    .do(evt => {
      if (evt instanceof HttpResponse) {
         if (evt.url.indexOf("GetSummaryCard") > -1 || evt.url.indexOf("GetDetailCard") > -1 || evt.url.indexOf("HeaderCard") > -1){
           if (this.globals.Session){
            this.sessionTimerService.sessionTimerStatus.next(1);
           }
         }
      }
    }) // 2 seconds
    .pipe(
      catchError((error: HttpErrorResponse) => {
        // console.log(error);
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        if (error instanceof TimeoutError) {
          return throwError('Timeout Exception');
        }
        
        return throwError(error); //it returns, handle it in service
      })
    )
  }
}